












import { Component, Vue } from 'nuxt-property-decorator';

import ComposePostIcon from '@/assets/svg/compose-post.vue.svg';

@Component<WarRoomPostButton>({
  name: 'WarRoomPostButton',
  components: {
    ComposePostIcon,
  },
})
export default class WarRoomPostButton extends Vue {
  handleClick(): void {
    this.$router.push({ name: 'war-room-posts-new' });
    this.$analytics.logEvent('war-room__create-a-post-mobile-button__click');
  }
}
